import React from 'react';
import './Catalogue.css';

const Catalogue = () => {
  const pdfPath = `${process.env.PUBLIC_URL}/purelife impex.pdf`;
  // Hide default viewer toolbar (download/print) where supported
  const pdfUrl = `${encodeURI(pdfPath)}#toolbar=0&navpanes=0&scrollbar=0`;

  return (
    <section className="catalogue-page section">
      <div className="container">
        <div className="catalogue-hero animate-fadeInUp">
          <h1 className="catalogue-title">Catalogue</h1>
          <p className="catalogue-subtitle">View our latest product catalogue.</p>
          {/* Removed explicit download/open actions per request */}
        </div>

        <div className="catalogue-viewer">
          <iframe
            title="Purelife Impex Catalogue"
            src={pdfUrl}
            className="catalogue-iframe"
          />
        </div>

        <p className="catalogue-note">
          If the embedded viewer doesn’t load, open this link in a new tab: <a href={pdfPath} target="_blank" rel="noopener noreferrer" title="Purelife impex Catalogue">Download Catalogue</a>
        </p>
      </div>
    </section>
  );
};

export default Catalogue;